import { useQuery } from "@tanstack/react-query";
import { getGroupDashboard, getGroupReportsWithSummaries, getGroupFilters } from "../../../services/reportService";
import { REPORT_KEYS } from "../queryKeys";

export function useDashboardQuery(groupId: string) {
  return useQuery({
    queryKey: REPORT_KEYS.dashboard(groupId),
    queryFn: () => getGroupDashboard(groupId),
    enabled: !!groupId,
  });
}

export function useGroupReportsQuery(groupId: string) {
  return useQuery({
    queryKey: REPORT_KEYS.groupReports(groupId),
    queryFn: () => getGroupReportsWithSummaries(groupId),
    enabled: !!groupId,
  });
}

export function useGroupFiltersQuery(groupId: string, enabled: boolean) {
  return useQuery({
    queryKey: REPORT_KEYS.groupFilters(groupId),
    queryFn: () => getGroupFilters(groupId),
    enabled: !!groupId && enabled,
  });
}
